"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Productexchangeinit = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var point_1 = require("../../model/point");
var service_1 = require("../../../library/base/service");
var Productexchangeinit = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(Productexchangeinit, _super);
    function Productexchangeinit() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '自有积分商品购买初始化接口';
        _this.code = '101106';
        _this.desc = '自有积分商品购买初始化接口';
        _this.requestParams = new point_1.ProductexchangeinitRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return Productexchangeinit;
}(service_1.BaseService));
exports.Productexchangeinit = Productexchangeinit;
//# sourceMappingURL=productexchangeinit.js.map